
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import main_logo from '../assets/images/main_logo.png';
import '../assets/css/navbar.css';
import SvgContent from "./Svgcontent";
import axios from "axios";
import configModule from '../../config.js';
import { useEffect, useState } from "react";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const config = configModule.config();
  const [courseCat, setCourseCat] = useState([]);

  const pathname = window.location.pathname;
  const basePath = pathname.split('/').slice(0, 2).join('/');
  const currentUrl = `${window.location.origin}${basePath}`;

  const isCoursesActive = location.pathname.startsWith("/courses");
  const goToContact = (pageName) => {
    if (pageName === "colleges") {
      navigate("/college_listing", { state: { scrollTo: pageName } });
    } else {
      navigate("/", { state: { scrollTo: pageName || "home" } });
    }
  };

  const getCourseCategory = async () => {

    try {
      const res = await axios.get(`${config.apiBaseUrl}/get-coursecat`, {
        headers: {
          "x-api-key": config?.apichKey
        }
      }
      );

      setCourseCat(res.data);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getCourseCategory();
  }, []);

  const closeMenu = () => {
    const toggle = document.getElementById("mbnav_toggle");
    if (toggle) toggle.checked = false;
  };

  const handleCall = () => {
    closeMenu();
    window.location.href = "tel:+919108703683";
  };

  return (
    <nav className="navbar-st" >
      <img src={main_logo} alt="main_logo" className="img-mainst" onClick={() => navigate("/")} />

      <div className="d-center navbarlink-st">

        <NavLink to="/" onClick={() => goToContact("home")} className={({ isActive }) => (isActive ? "active-link" : "")} >Home</NavLink>

        {/* COURSES DROPDOWN */}
        <div className="dropdown">
          <span className={isCoursesActive ? "active-link dropbtn" : "dropbtn"}>Courses ▾</span>
          <div className="dropdown-content-main ">
            {Array.isArray(courseCat) && courseCat?.length > 0 && courseCat.map((item, idx) => (
              <div className="dropdown-content" key={idx} onClick={() => {
                navigate(
                  `/${item.id}/best-colleges-under-${item.category.toLowerCase()}`,
                  { state: item }
                );
                closeMenu();
              }}  >
                <SvgContent svg_name={item.icon_class_name} stroke="#64748B" />&nbsp;&nbsp;
                <p style={{ color: "#64748B" }}>{item.category}</p>
              </div>
            ))}
          </div>
        </div>

        <NavLink to="/college_listing" onClick={() => goToContact("colleges")} className={({ isActive }) => (isActive ? "active-link" : "")}>Colleges</NavLink>
        <NavLink to="/exam-index" className={({ isActive }) => (isActive ? "active-link" : "")}>Exams</NavLink>
        <NavLink to="/scholarship-index" className={({ isActive }) => (isActive ? "active-link" : "")}>Scholarships</NavLink>
        <NavLink to="/question-answer" className={({ isActive }) => (isActive ? "active-link" : "")}>Q&A</NavLink>
        <NavLink
         to="#"
         onClick={(e) => {
           e.preventDefault();
           window.location.href = "https://campushunt.in/blog/";
         }}
        >
          Blog
        </NavLink>

      </div>

      <button className="contact-usst" onClick={() => goToContact("contact")}>
        Contact Us
      </button>

      <input type="checkbox" id="mbnav_toggle" hidden />

      <label htmlFor="mbnav_toggle" className="mb-navbarlink-st">
        <SvgContent svg_name="menu_bar" stroke="#5e5c5c" />
      </label>
      <label htmlFor="mbnav_toggle" className="mbnav_overlay"></label>


      <div className="mbnav_sidebar">
        <div className="headmbnav-st">
          <img src={main_logo} alt="main_logo" className="img-mainst" onClick={() => navigate("/")} />
          <label htmlFor="mbnav_toggle" className="mb-navbarlink-st">
            <SvgContent svg_name="close" stroke="#5e5c5c" />
          </label>
        </div>
        <NavLink to="/" onClick={() => { goToContact("home"); closeMenu(); }}>
          Home
        </NavLink>

        {/* COURSES */}
        <div className="mbnav_dropdown">

          <input type="checkbox" id="mbnav_course_toggle" hidden />

          <label htmlFor="mbnav_course_toggle" className="mbnav_dropbtn">
            Courses ▾
          </label>

          <div className="mbnav_dropdown_content ">
            {Array.isArray(courseCat) && courseCat?.length > 0 && courseCat.map((item, idx) => (
              <div className="dropdown-content" key={idx} onClick={() => {
                navigate(
                  `/${item.id}/best-colleges-under-${item.category.toLowerCase()}`,
                  { state: item }
                );
                closeMenu();
              }} >
                <SvgContent svg_name={item.icon_class_name} stroke="#64748B" />&nbsp;&nbsp;
                <p style={{ color: "#64748B" }}>{item.category}</p>
              </div>
            ))}
          </div>
        </div>

        <NavLink to="/college_listing" onClick={() => { goToContact("colleges"); closeMenu(); }}>
          Colleges
        </NavLink>

        <NavLink to="/exam-index" onClick={closeMenu}>
          Exams
        </NavLink>
        <NavLink to="/scholarship-index" onClick={closeMenu}>
          Scholarships
        </NavLink>
        <NavLink to="/question-answer" onClick={closeMenu}>
          Q&A
        </NavLink>

        <NavLink
          to="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "https://campushunt.in/blog/";
          }}
        >
          Blog
        </NavLink>

        <div className="m-drawer-footer" onClick={() => { closeMenu(); handleCall(); }}>
          <button>
            Call +91 91087 03683
          </button>
        </div>


      </div>
    </nav>
  );
};

export default Navbar;